/** @format */

import { AddressAccountSettings } from './address-account-settings.interface';
import { RewardDeliverySettings } from './reward-delivery-settings.interface';
import { SubscriptionSettings } from './subscription-settings.interface';

export interface AccountSettings {
  addresses: AddressAccountSettings[];
  couldNotRetrieveSettings: boolean;
  rewardDeliverySettings: RewardDeliverySettings;
  subscriptionSettings: SubscriptionSettings;
}
